import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountType } from 'models/Account';

export interface AccountTypeProps {
  type: AccountType;
}

const initialState: AccountTypeProps = {
  type: 'PERSONAL'
};

export const accountTypeSlice = createSlice({
  name: 'accountType',
  initialState,
  reducers: {
    setAccountType: (
      state,
      action: PayloadAction<{
        type: AccountType;
      }>
    ) => {
      state.type = action.payload.type;
    },
    toggleAccountType: state => {
      state.type = state.type === 'PERSONAL' ? 'BUSINESS' : 'PERSONAL';
    }
  },
  selectors: {
    getAccountType: state => state.type
  }
});

export const { setAccountType, toggleAccountType } = accountTypeSlice.actions;
export const { getAccountType } = accountTypeSlice.selectors;
